<template>
  <div class="login-container">
    <!-- 移动端登录 -->
    <div class="mobile-login">
      <div class="logo-section">
        <div class="logo-icon">✓</div>
        <h1 class="logo-text">TaskFlow</h1>
        <p class="logo-slogan">高效管理，轻松完成</p>
      </div>

      <div class="form-section">
        <div class="input-group">
          <label class="input-label">邮箱地址</label>
          <a-input v-model="form.email" placeholder="请输入邮箱地址" class="login-input" />
        </div>

        <div class="input-group">
          <label class="input-label">密码</label>
          <a-input-password v-model="form.password" placeholder="请输入密码" class="login-input" />
        </div>
      </div>

      <a-button type="primary" class="login-button" @click="handleLogin"> 登录 </a-button>

      <div class="register-link">
        <span>还没有账号？</span>
        <a href="/taskflow/register" class="register-action">立即注册</a>
      </div>
    </div>

    <!-- PC端登录 -->
    <div class="pc-login">
      <div class="brand-section">
        <div class="logo-icon">✓</div>
        <h1 class="logo-text">TaskFlow</h1>
        <p class="logo-slogan">高效管理，轻松完成</p>
        <p class="brand-description">专业的任务管理系统，帮助您高效组织工作， 提升团队协作效率，实现目标管理的最佳选择。</p>
      </div>

      <div class="form-section">
        <h2 class="form-title">用户登录</h2>
        <div class="input-group">
          <label class="input-label">邮箱地址</label>
          <a-input v-model="form.email" placeholder="请输入邮箱地址" class="login-input" />
        </div>

        <div class="input-group">
          <label class="input-label">密码</label>
          <a-input-password v-model="form.password" placeholder="请输入密码" class="login-input" />
        </div>

        <a-button type="primary" class="login-button" @click="handleLogin" :loading="loading"> 登录 </a-button>

        <div class="register-link">
          <span>还没有账号？</span>
          <a href="/taskflow/register" class="register-action">立即注册</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        email: '',
        password: ''
      },
      loading: false
    };
  },
  methods: {
    handleLogin() {
      // 登录逻辑
      if (this.form.email && this.form.password) {
        // 设置loading状态
        this.loading = true;
        // 调试信息
        console.log('登录请求数据:', this.form);
        // 调用登录API
        this.$http
          .post('/api/auth/login', this.form)
          .then(response => {
            console.log('登录响应数据:', response);
            if (response.success) {
              // 保存登录状态
              localStorage.setItem('token', response.data.token);
              localStorage.setItem('user', JSON.stringify({ email: response.data.email }));
              // 跳转到任务列表页面
              this.$router.push('/taskflow/task-list');
              this.$message.success('登录成功');
            } else {
              this.$message.error(response.message || '登录失败');
            }
          })
          .catch(error => {
            console.error('登录失败:', error);
            this.$message.error('登录失败，请稍后重试');
          })
          .finally(() => {
            // 关闭loading状态
            this.loading = false;
          });
      } else {
        this.$message.error('请填写邮箱和密码');
      }
    }
  }
};
</script>

<style lang="less">
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  padding: 20px;

  .mobile-login {
    display: none;
    max-width: 375px;
    width: 100%;
    background-color: #fff;
    border-radius: 40px;
    padding: 24px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    .logo-section {
      text-align: center;
      margin-bottom: 24px;

      .logo-icon {
        font-size: 48px;
        font-weight: 700;
        color: #4caf50;
        margin-bottom: 12px;
      }

      .logo-text {
        font-size: 28px;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 12px;
      }

      .logo-slogan {
        font-size: 14px;
        color: #666666;
      }
    }

    .form-section {
      margin-bottom: 24px;

      .input-group {
        margin-bottom: 20px;

        .input-label {
          display: block;
          font-size: 14px;
          font-weight: 500;
          color: #1a1a1a;
          margin-bottom: 6px;
        }

        .login-input {
          width: 100%;
          height: 44px;
          border-radius: 6px;
        }
      }
    }

    .login-button {
      width: 100%;
      height: 48px;
      background-color: #4caf50;
      border-color: #4caf50;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 24px;
    }

    .register-link {
      text-align: center;
      font-size: 14px;

      span {
        color: #666666;
      }

      .register-action {
        color: #4caf50;
        font-weight: 600;
        margin-left: 8px;
      }
    }
  }

  .pc-login {
    display: flex;
    max-width: 800px;
    width: 100%;
    background-color: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    .brand-section {
      flex: 1;
      background-color: #4caf50;
      padding: 48px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #fff;

      .logo-icon {
        font-size: 64px;
        font-weight: 700;
        margin-bottom: 24px;
      }

      .logo-text {
        font-size: 36px;
        font-weight: 700;
        margin-bottom: 16px;
      }

      .logo-slogan {
        font-size: 16px;
        margin-bottom: 24px;
      }

      .brand-description {
        text-align: center;
        line-height: 1.5;
      }
    }

    .form-section {
      flex: 1;
      padding: 48px;

      .form-title {
        font-size: 24px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 32px;
      }

      .input-group {
        margin-bottom: 24px;

        .input-label {
          display: block;
          font-size: 14px;
          font-weight: 500;
          color: #1a1a1a;
          margin-bottom: 6px;
        }

        .login-input {
          width: 100%;
          height: 44px;
          border-radius: 6px;
        }
      }

      .login-button {
        width: 100%;
        height: 48px;
        background-color: #4caf50;
        border-color: #4caf50;
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 24px;
      }

      .register-link {
        text-align: center;
        font-size: 14px;

        span {
          color: #666666;
        }

        .register-action {
          color: #4caf50;
          font-weight: 600;
          margin-left: 8px;
        }
      }
    }
  }

  // 响应式设计
  @media (max-width: 768px) {
    .mobile-login {
      display: block;
    }

    .pc-login {
      display: none;
    }
  }
}
</style>
